import './accordionBtn.css'
import Icon from "../../component/Icon/Icon";
import {Button} from "react-bootstrap";
import React from "react";

function AccordionBtn ({showAccordion, label, onClick}){

  return(
    <div className="accordion-container">
      <Button style={{backgroundColor: `${showAccordion ? "#e7f1ff" : ""}`}} className="accordion-btn shadow-none" onClick={onClick}>
        <label className='accordion-label'>{label}</label>
        <Icon
          style={{transform: `rotate(${showAccordion ? 0 : "0.5turn"})`, transition: "all 0.5s ease"}}
          icon="fa-thin fa-chevron-down"
        />
      </Button>
    </div>
  )

}
export default AccordionBtn;



// WEBPACK FOOTER //
// ./src/Inventory/components/AccordionBtn.js